export default {
  C202a: 423, // 'C2-02a/NS: Giấy rút dự toán ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
  C202b: 500, // 'C2-02b/NS: Giấy rút dự toán ngân sách (Nghị định 11/2020/NĐ-CP)',
  Ms07: 99, // 'Mẫu số 07: Bảng kê nội dung thanh toán tạm ứng',
  C402a: 425, //'C4-02a/NS: Ủy nhiệm chi chuyển khoản, chuyển tiền điện tử',
  C402c: 421, //'C4-02c/NS: Ủy nhiệm chi chuyển khoản, chuyển tiền điện tử ',
  M05tt: 93, // 'Mẫu 05TT: Giấy rút vốn đầu tư (Nghị định 99/2021/NĐ-CP)',
  C203: 88, //'C2-03/NS: Giấy đề nghị thanh toán tạm ứng/ứng trước (Nghị định 11/2020/NĐ-CP)',
  C205a: 424, // 'C2-05a/NS: Giấy nộp trả kinh phí (Nghị định 11/2020/NĐ-CP)',
  M04att: 161, //'Mẫu 04.a.TT: Giấy đề nghị thanh toán vốn (Nghị định 99/2021/NĐ-CP)',
  M04btt: 94, //'Mẫu 04.b.TT: Giấy đề nghị thu hồi vốn (Nghị định 99/2021/NĐ-CP)',
  Ms09: 283, //'Mẫu số 09: Bảng thanh toán cho đối tượng thụ hưởng',
};
